import Link from 'next/link';
import Image from 'next/image';

const ArticleCard = ({ imgSrc, title, summary, link }: any) => {
    return (
        <div className="rounded overflow-hidden shadow-lg my-2">
            <Link legacyBehavior href={link}>
                <a>
                    <div className="relative h-48 w-full">
                        <Image
                            src={imgSrc}
                            alt={title}
                            fill
                            className="object-cover"
/>
                    </div>
                </a>
            </Link>
            <div className="px-6 py-4">
                <div className="font-bold text-xl mb-2">
                    <Link legacyBehavior href={link}>
                        <a>{title}</a>
                    </Link>
                </div>
                <p className="text-gray-700 text-base">
                    <Link legacyBehavior href={link}>
                        <a>{summary}</a>
                    </Link>
                </p>
            </div>
            <div className="px-6 pt-4 pb-2">
                <Link legacyBehavior href={link}>
                    <a className="inline-block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                        Read More
                    </a>
                </Link>
            </div>
        </div>
    );
};

export default ArticleCard;
